/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
export class AppSettings {
  public static readonly production = false;
  public static readonly APPNAME = "Yene";
  public static readonly APPYEAR = new Date().getFullYear();
  public static readonly defaultPhoneCode = "+264";
  public static readonly defaultlang = "EN";
  public static readonly defaultcur = "$";
  public static readonly defaultCountryId = "63"; //Ecuador
  public static readonly defaultStateId = "1022"; //TN
  public static readonly GOOGLE_MAP_DEFAULT_LOCATION = "Walvis Bay, Namibia"; // It is used for showing default location of google map to show the location details*/
  public static readonly MAP_ZOOM = 6;
  public static readonly GoogleMapKey = "AIzaSyCftiwpCjI4-_0NSm_NyodvYNpdKAA2Imk";
  public static readonly logo_URL = "assets/images/logo.png";
  public static readonly defaultProfileImage = "assets/images/defaultUser.svg";
  public static readonly version = "2.0.4";
  public static readonly showLogo = false;
  public static readonly showTitle = true;
  public static readonly logo_height = 50;
  public static readonly logo_width = 100;
  public static readonly secondCurrency = "NAD";
  public static readonly googleAutocomplete = false; // if it is true fetch location via google map. else fetch our database.
  public static readonly shareTripUrl = 'https://crm.yetuyene.com/share-trip/'
}

export const environment = {
  production: false,
  // API_ENDPOINT: "http://10.1.1.43:5000/",
  // BASEURL: "http://10.1.1.43:5000/",
  // API_ENDPOINT: "http://localhost:3004/",
  // BASEURL: "http://localhost:3004/",
  // API_ENDPOINT: "http://localhost:3000/",
  // BASEURL: "http://localhost:3000/",
  // API_ENDPOINT: "http://10.1.1.29:3004/",
  // BASEURL: "http://10.1.1.29:3004/",
  // API_ENDPOINT: "http://10.1.1.27:3004/",
  // BASEURL: "http://10.1.1.27:3004/",
  API_ENDPOINT: "https://crm.yetuyene.com/api/",
  BASEURL: "https://crm.yetuyene.com/api/",
  IMGURL: "https://crm.yetuyene.com",
  // API_ENDPOINT: "https://rebustarv3api.abservetechdemo.com/",
  // BASEURL: "https://rebustarv3api.abservetechdemo.com/",
  GoogleMapKey: "AIzaSyCftiwpCjI4-_0NSm_NyodvYNpdKAA2Imk",
  defaultCountryLat: -22.9576,
  defaultCountryLan: 18.4904,

  // driver_App_link: 'https://play.google.com/store/apps/details?id=com.rebustar.driver',
  // rider_App_link: 'https://play.google.com/store/apps/details?id=com.rebustar.rider',
  // driver_Android_link: 'https://play.google.com/store/apps/details?id=com.rebustar.driver',
  // rider_Android_link: 'https://play.google.com/store/apps/details?id=com.rebustar.rider',
};

export class FeaturesSettings {
  public static readonly isdownload = true;
  public static readonly isDemoMode = true;
  public static readonly demoEmail = "admin@rebustar.com";
  public static readonly demoPassword = "123456";
  public static readonly isDTS = false;
  public static readonly isCityWise = true; //Vehicle and Fare etc act citywise  0/1
  public static readonly isHotel = false; //Vehicle and Fare etc act citywise  0/1
  public static readonly isServiceAvailable = true; //if not modify in getServiceBasicfare
  public static readonly isCommisionToAdmin = true; //is at end of trip Commision need to take
  public static readonly isMultipleCompaniesAvailable = false;
  public static readonly isDoubleChargeNeeded = false; //is isDoubleChargeNeeded for crossing City limit
  public static readonly applyNightCharge = true;
  public static readonly applyPeakCharge = true;
  public static readonly applyWaitingTime = true; //waiting time charge
  public static readonly applyTax = true;
  public static readonly applyCommission = true;
  public static readonly applyPickupCharge = true;
  public static readonly isRiderCancellationAmtApplicable = true;
  public static readonly isDriverCancellationAmtApplicable = false;
  public static readonly applyBlockOldCancellationAmt = true;
  public static readonly isDriverCreditModuleEnabled = true; //Helps to show alert if credits are low, reduce commision from credits, etc
  public static readonly adminCommision = "driverWallet"; //From Driver Wallet (driverWallet)
  public static readonly payoutType = "driverPostpaid"; //Driver Have to Recharge to Take Trip. (driverPrepaidWallet,driverPostpaidWallet)
  public static readonly deductAmountFromDriverWallet = "commision"; //this amount will be decuted from Wallet (totalFare,commision)
  public static readonly isRiderReferalCodeAvailable = false;
  public static readonly isPromoCodeAvailable = true;
  public static readonly isOffersForRideAvailable = false;
  public static readonly tripsAvailable = ["Daily"]; //USED
  public static readonly fareCalculationType = "normal"; //{indiaGst,normal}
  public static readonly distanceUnit = "Miles"; //KM or Miles
  public static readonly showHailTrips = false; //show hail related stuffs
  public static readonly paymentType = ["credit", "debit"];
  public static readonly payPackageTypes = ["TOPUP", "SUBSCRIPTION"];
  public static readonly paymentTypes = ["TOPUP", "SUBSCRIPTION"];
  public static readonly subPackageTypes = ["subscription"]; // 'subscription,commission,topup' - DRIVER SUBSCRIPTION MENU
  public static readonly shareTaxi = false; // Is Vehicle Sharing Available in Vehicle Type
  public static readonly taxFeeLabel = "Tax"; // Access Fee or Tax
  public static readonly showDeliveryTrips = false; // Delivery Trips and Report
  public static readonly isVehicleTypeAvailableInPackages = false; // Vehicle Type while adding package in Driver Credits.
  // public static readonly defaultVehicleInMap = 'Sedan'; // Gods View and Tracking
  public static readonly defaultVehicleInMap = "ALL"; // Gods View and Tracking
  public static readonly referenceCode = false;
  public static readonly langAvailable = ["en", "es"];
  public static readonly DefaultCountry = "63";
  public static readonly DefaultState = "1022";
  public static readonly ServiceAvailableCity = localStorage.getItem("cityType");
  public static readonly Nb_dialogbox_close_while_click_outside = false;
  public static readonly DateFormatWithTime = "DD-MM-YYYY H:mm:ss";
  public static readonly DateFormat = "DD-MM-YYYY";
  public static readonly TimeFormat = "h:mm a";
  public static readonly TableSort = false;
  public static readonly PasswordPattern =
    "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@#$%^&+=]).{8,}$";
  public static readonly NoPlatePattern =
    "^[A-Z]{2}[\\ -]{0,1}[0-9]{1,2}[\\ -]{0,1}[A-Z]{1,2}[\\ -]{0,1}[0-9]{4}$";
  public static readonly dailySlug = 'daily'
  public static readonly showExpandableTable = false

}
export class YearSelection {
  public static readonly year = () => {
    let startYear = new Date().getFullYear();
    let range = [];
    for (let i = 0; i < 24; i++) {
      range.push(startYear - i);
    }
    return range.map(String);
  };
}

export class LanguageSettings {
  public static readonly languages = ["en", "es"];
  public static readonly defaultSelectedLang = "en";
  public static readonly setLanguageForMenus = false;
  public static readonly showTranslateOption = false;
  public static readonly fetchTranslateFilesFromAPI = true;
}

export class CommonData {
  public static readonly currency = [
    { value: "NAD", label: "Namibia - NAD $" },
    // { value: "US", label: "USA - $" },
  ];
  public static readonly language = [
    { value: "en", label: "English" },
    { value: "es", label: "Spanish" },
    // { value: "ta", label: "Tamil" },
  ];
  public static readonly defaultLanguage = [
    { indexName: "en", name: "English" },
    { indexName: "es", name: "Spanish" },
    // { indexName: "ta", name: "Tamil" },
  ];
  public static readonly adminType = [
    { value: "superadmin", title: "Super Admin" },
    // { value: "citywiseadmin", label: "City Wise Admin" },
  ];
  public static readonly ownertype = [
    { value: "COMPANY", label: "Company" },
    { value: "PARTNER", label: "Partner" },
  ];
  public static readonly gender = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "Others", label: "Others" },
  ];
  public static readonly genders = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "Others", label: "Others" },
    { value: "All", label: "All" },
  ];
  public static readonly LowerServiceTypes = [{ value: 0, label: "Mini" }];
  public static readonly tripType = [
    { value: "daily", label: "Daily" },
  ];
  public static readonly tripType1 = [
    {
      name: "Daily",
      slug: "daily"
    },
  ];
  public static readonly offerTypes = [
    { value: "Flatrate", label: "Flat Rate" },
    { value: "Percentage", label: "Percentage" },
  ];
  public static readonly true_or_false = [
    { value: true, label: "Yes" },
    { value: false, label: "No" },
  ];
  public static readonly zero_or_one = [
    { value: 1, label: "Yes" },
    { value: 0, label: "No" },
  ];
  public static readonly available_or_unavailable = [
    { value: "Available", label: "Yes" },
    { value: "Un-available", label: "No" },
  ];
  public static readonly status = [
    { value: true, label: "Enable" },
    { value: false, label: "Disable" },
  ];
  public static readonly category = [
    { value: "Promotion", label: "Promotion" },
    { value: "Promocode", label: "PromoCode" },
  ];
  public static readonly apply_type = [
    { value: "Auto", label: "Auto" },
    { value: "Manual", label: "Manual" },
  ];
  public static readonly fareType0 = [
    { value: "unitRate", label: "Unit Rate" },
    { value: "flatRate", label: "Flat Rate" },
  ];
  public static readonly fareType1 = [
    { value: "amount", label: "Amount" },
    { value: "percentage", label: "Percentage" },
  ];

  //ng2-smart-table drop down options
  public static readonly accountStatus = [
    { value: "", title: "All" },
    { value: "Pending", title: "Pending" },
    { value: "Active", title: "Active" },
    { value: "Inactive", title: "Inactive" },
    // { value: "Blocked", title: "Blocked" },
  ];
  public static readonly onlineStatus = [
    { value: "", title: "All" },
    { value: "1", title: "Online" },
    { value: "0", title: "Offline" },
  ];
  public static readonly onlineoffline = [
    { value: "1", title: "Online" },
    { value: "0", title: "Offline" },
  ];
  public static readonly tripsStatus = [
    { value: "", title: "All" },
    { value: "Processing", title: "Processing" },
    { value: "Accepted", title: "Accepted" },
    { value: "Arrived", title: "Arrived" },
    { value: "Progress", title: "Progress" },
    { value: "Finished", title: "Finished" },
    { value: "Cancelled", title: "Cancelled" },
    { value: "Noresponse", title: "Noresponse" },
  ];
  public static readonly paymentMode = [
    { value: "", title: "All" },
    { value: "Cash", title: "Cash" },
    // { value: "Card", title: "Card" },
  ];
  public static readonly packageType = [
    { value: "", title: "All" },
    { value: "TOPUP", title: "TOPUP" },
    { value: "SUBSCRIPTION", title: "SUBSCRIPTION" },
  ];
  public static readonly subscriptionStatus = [
    { value: "", title: "All" },
    { value: "Active", title: "Active" },
    { value: "Inactive", title: "In Active" },
    { value: "Pending", title: "Pending" },
  ];
  public static readonly activeInactive = [
    { value: "true", title: "Active" },
    { value: "false", title: "In Active" },
  ];
  public static readonly bookingType = [
    {
      disabled: false,
      value: "rideNow",
      label: "Ride Now",
    },
    {
      disabled: true,
      value: "rideLater",
      label: "Ride Later (Scheduled Trip)",
    },
  ];
  public static readonly AssignmentType = [
    {
      disabled: false,
      value: "auto-assign",
      label: "Auto Assign",
    },
    {
      disabled: false,
      value: "manual-assign",
      label: "Manual Assign",
    },
  ];

}
